export default __webpack_public_path__ + "static/media/icon-heart.ede823bb.svg";